import { NestedTableNodeTree } from 'ui/treeView';
import {
  CampaignIdToMetadataMap,
  Sort,
  StoredCampaignBreakdowns,
  StoredSnippetBreakdowns,
  ThumbnailResp,
} from '../types';
import { getSnippetBreakdownRows } from './getSnippetBreakdownRows';
import { getCampaignBreakdownRows } from './getCampaignBreakdownRows';

export const getTableWithBreakdownRows = (
  baseLevelRows: NestedTableNodeTree[],
  storedSnippetBreakdowns: StoredSnippetBreakdowns,
  storedCampaignBreakdowns: StoredCampaignBreakdowns,
  expandedBaseLevelSnippetIds: number[],
  sort: Sort,
  showCampaigns: boolean,
  campaignIdToMetadataMap: CampaignIdToMetadataMap,
  thumbnails: ThumbnailResp,
) => {
  return baseLevelRows.reduce((combinedRows, currRow) => {
    const id = currRow.id.toString();
    if (expandedBaseLevelSnippetIds.includes(parseInt(id, 10))) {
      const updatedRow = showCampaigns
        ? getCampaignBreakdownRows(
            storedCampaignBreakdowns[id],
            currRow,
            campaignIdToMetadataMap,
            thumbnails,
            sort,
          )
        : getSnippetBreakdownRows(storedSnippetBreakdowns[id], id, sort);
      return [...combinedRows, updatedRow || currRow];
    }
    return [...combinedRows, currRow];
  }, [] as NestedTableNodeTree[]);
};
